module.exports = __webpack_public_path__ + "img/quasar-respuesta.4a7dfc78.png";